import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { LogService } from '../../../../services/log-service';
import { messages } from '../messages/export-order-headers';

export const FormattedExportHeader = ({ fieldId, fieldName = null }) => {
  if (fieldName !== null && fieldId !== fieldName) {
    return fieldName;
  }
  if (!(fieldId in messages)) {
    LogService.logError(new Error('Missing order export header label'), { fieldId });
    return fieldId;
  }
  return <FormattedMessage {...messages[fieldId]} />;
};

FormattedExportHeader.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string,
};
